import React from 'react';
import styled from 'styled-components';
import LoginForm from '../components/LoginForm';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
`;

const LoginPage = () => {
  return (
    <PageContainer>
      <MainContent>
        <LoginForm />
      </MainContent>
    </PageContainer>
  );
};

export default LoginPage; 